export default function ExplainPoints({points}) {
  return (
    <span>{getDescription(points)}</span>
  )
}

export function PlainExplainPoints({points}) {
  return (
    getDescription(points)
  )
}

export function colorizeTextPoints(points) {
  return "text-" + colorizePoints(points);
}

export function colorizeBgPoints(points) {
  return "bg-" + colorizePoints(points);
}

function colorizePoints(points) {
  let color = ""
  switch (points) {
    case 10:
      color = "green-500";
      break;
    case 7:
      color = "orange-500";
      break;
    case 5:
      color = "yellow-500";
      break;
    case 2:
      color = "purple-500";
      break;
    default:
      color = "black";
  }

  return color;
}

export function LoadAllToolTipsPoints() {
  const values = [10, 7, 5, 2, 0];

  return (
    <>
      {values.map((value) => (
        <LoadToolTipsPoints key={"parent-tooltip-" + value + "-points"} points={value} />
      ))}
    </>
  )
}

export function LoadToolTipsPoints({points}) {
  return (
    <div id={"tooltip-" + points + "-points"} key={"tooltip-" + points + "-points"} role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip dark:bg-gray-700">
      {getDescription(points)}
      <div className="tooltip-arrow" data-popper-arrow></div>
    </div>
  )
}

const getDescription = (points) => {
    switch (points) {
      case 10:
        return "Acertou o placar exato do jogo";
      case 7:
        return "Acertou o vencedor e o placar de um dos times";
      case 5:
        return "Acertou o time vencedor ou empate mais errou na totalidade o placar";
      case 2:
        return "Acertou o placar de um dos times mais errou o time vencedor ou empate";
      case 0:
        return "Nenhum acerto";
      default:
        return "Não palpitou";
    }
}
